document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('store-header.header');

  if (!header) return;

  const updateHeader = () => {
    header.classList.toggle('header--scrolled', window.scrollY > 20);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
});